import React from 'react'

import * as MdIcons from 'react-icons/md'
import { useTheme } from 'styled-components'

import { Container, MessageContainer, MessageText } from './styles'

export function OfflineContainer() {
  const theme = useTheme()
  return (
    <Container>
      <MessageContainer>
        <MdIcons.MdWifiOff size={50} color={theme.colors.text} />
        <MessageText>
          This task could not be loaded because you are offline.
        </MessageText>
        <MessageText>Please check your connection and try again.</MessageText>
      </MessageContainer>
    </Container>
  )
}
